export type SugarMoneyApiRequestPayoutResponseType = {
  serialisedTransaction: string;
  blockhash: string;
  lastValidBlockHeight: number;
  nonce: number;
};

export type SugarMoneyApiSubmitPayoutRequestType = {
  signed_tx: string;
  nonce: number;
  blockhash: string;
  lastValidBlockHeight: number;
};

export type SugarMoneyApiSubmitPayoutResponseType = string;

export type SugarMoneyApiPayoutProgressResponseType = {
  expiresAt: number;
  inProgress: boolean;
};

export enum PayoutStatus {
  Pending = 'PENDING',
  Paid = 'PAID',
  Failed = 'FAILED',
}

export enum SugarMoneyTransactionStatusEnum {
  Processing = 'processing',
  Success = 'success',
  Failed = 'failed',
  Dropped = 'dropped',
  NotFound = 'not_found',
}

export type SugarMoneyTransactionStatusResponseType = {
  signature: string;
  status: SugarMoneyTransactionStatusEnum;
};
